import type { SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';

import type { TableSelectorProps, UseTableSelectorResult } from '../types';

export const useTableSelector = ({
  options,
  selectedId,
  onChange,
}: TableSelectorProps): UseTableSelectorResult => {
  const selectedIndex = useMemo(
    () => options.findIndex((option) => option.id === selectedId),
    [options, selectedId]
  );

  const onSelectChange = (event: SelectChangeEvent) => onChange(event.target.value);

  // Stepping stops at either end rather than wrapping, so the arrows show where the
  // selection sits in the list.
  const hasPrevious = selectedIndex > 0;
  const hasNext = selectedIndex >= 0 && selectedIndex < options.length - 1;
  const onStep = (offset: -1 | 1) => {
    const target = options[selectedIndex + offset];
    if (target) onChange(target.id);
  };

  return { selectedIndex, onSelectChange, hasPrevious, hasNext, onStep };
};
